import { Body, useLocales } from "@/lib/main";
import { DonutChartPropTypes } from "@/lib/types/visualizations/charts/DonutChart.types";
import DonutChartFigCaption from "./DonutChartFigCaption";
import DonutChartFigure from "./DonutChartFigure";
import DonutChartItem from "./DonutChartItem";

export default function DonutChart({
  size,
  chartTitle,
  donutLabel,
  units,
  blueLabel,
  blueValue,
  yellowLabel,
  yellowValue,
  greenLabel,
  greenValue,
  redLabel,
  redValue,
  fullWidth,
  showPercentages,
}: DonutChartPropTypes) {
  const l = useLocales();

  return (
    <DonutChartFigure fullWidth={fullWidth}>
      <Body size="lg" fontWeight={500}>
        {l(chartTitle)}
      </Body>

      <DonutChartItem
        size={size}
        donutLabel={donutLabel}
        blueValue={blueValue}
        yellowValue={yellowValue}
        greenValue={greenValue}
        redValue={redValue}
      />

      <DonutChartFigCaption
        units={units}
        blueLabel={blueLabel}
        blueValue={blueValue}
        yellowLabel={yellowLabel}
        yellowValue={yellowValue}
        greenLabel={greenLabel}
        greenValue={greenValue}
        redLabel={redLabel}
        redValue={redValue}
        showPercentages={showPercentages}
      />
    </DonutChartFigure>
  );
}
